import axios from 'axios';

const aclInstance = axios.create({
	baseURL: process.env.ACL_URL,
});

const quipuInstance = axios.create({
	baseURL: process.env.QUIPU_URL,
});

const salesInstance = axios.create({
	baseURL: process.env.SALES_URL,
});
const productsInstance = axios.create({
	baseURL: process.env.PRODUCTS_URL,
});

const productionInstance = axios.create({
	baseURL: process.env.PRODUCTION_URL,
});

export default function (Vue) {
	/* eslint-disable no-param-reassign */
	Vue.prototype.$httpAcl = aclInstance;
	Vue.prototype.$http = quipuInstance;
	Vue.prototype.$httpSales = salesInstance;
	Vue.prototype.$httpProducts = productsInstance;
	Vue.prototype.$httpProduction = productionInstance;
}



// WEBPACK FOOTER //
// ./src/axios.js